import { useRouter } from 'next/router';
import { MouseEventHandler, useCallback, useRef } from 'react';
import { Button, IconButton } from 'ui-components/dist/Button';
import { PlusIcon } from 'ui-components/dist/PlusIcon';
import { useAddTalentStore } from '~/screens/AddTalent';

interface AddTalentButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  size?: 'sm' | 'md' | 'lg';
  sx?: any;
  isDropdown?: boolean;
}

export const AddTalentButton: React.FC<AddTalentButtonProps> = ({
  isDropdown = false,
  ...props
}) => {
  const router = useRouter();
  const hasOpenedAddTalentModalFromExtension = useRef(false);

  const { setIsModalOpen: openNewAddTalentModal } = useAddTalentStore();

  const isShared = router.pathname === '/shared/[agency]';
  const hasAddTalentQueryParamInUrl = router.query.addTalent === 'true';

  if (
    hasAddTalentQueryParamInUrl &&
    !hasOpenedAddTalentModalFromExtension.current
  ) {
    hasOpenedAddTalentModalFromExtension.current = true;
    openNewAddTalentModal(true);
  }

  const handleOpenAddTalent = useCallback(() => {
    openNewAddTalentModal(true);
  }, [openNewAddTalentModal]);

  if (isShared) return null;

  if (!isDropdown) {
    return (
      <>
        <Button
          size="md"
          leftIcon={<PlusIcon boxSize={4} />}
          trackId="foam-topnav-menu-add-talent-button"
          aria-label="Add Talent Button"
          onClick={handleOpenAddTalent}
          sx={{
            display: { base: 'none', md: 'flex' },
          }}
        >
          Add Talent
        </Button>

        <IconButton
          aria-label="Add Talent"
          size="md"
          variant="primary"
          sx={{
            display: {
              base: 'block',
              md: 'none',
            },
          }}
          onClick={handleOpenAddTalent}
          icon={<PlusIcon boxSize={4} />}
        />
      </>
    );
  }

  return (
    <Button
      size="sm"
      leftIcon={<PlusIcon boxSize={4} />}
      trackId="foam-topnav-menu-add-talent-button"
      aria-label="Add Talent Button"
      onClick={handleOpenAddTalent}
      sx={{ width: 'full' }}
      {...props}
    >
      Add Talent
    </Button>
  );
};
